import { type ErrorContexts, type WithContext } from '@lingoda/errors';

interface Options {
    context: ErrorContexts;
}

export class BrowserTimeSyncError extends Error implements WithContext {
    public readonly context?: ErrorContexts;

    constructor(message: string, options: Options) {
        const { context } = options;
        super(message);
        this.name = 'BrowserTimeSyncError';
        this.context = context;
    }
}
